<template>
  <Loading v-if="statusLoading === 'true'"></Loading>
  <section class="row d-flex flex-row p-2 mt-5"  v-else >
   <div class="col-md-4 col-lg-4  pricing-tables mt-3 " v-for="(list , index) in listPanel" >
            <div class="w-full max-w-sm  bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700 border-b-cyan-900  border-4 border-indigo-200 border-t-indigo-500">
              <h5 class="mb-4 text-sm font-bold text-bold  text-gray-900 dark:text-gray-800 text-center  " >{{ list.title }}</h5>
              <hr>
              <div class="flex items-baseline text-gray-900 dark:text-black justify-center">
                <span class="text-3xl ms-1 font-extrabold tracking-tight">{{ number.numberFormats(list.price) }}</span>
                <span class="text-2xl font-semibold">تومان</span>
              </div>
              <table class="table table-striped">
                <tbody>
                <tr>
                  <td class="text-right" ><span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-800 ms-3">تعداد کد های تخفیف</span></td>
                  <td><span >{{ list.discount }}</span></td>
                </tr>
                <tr>
                  <td class="text-right" ><span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-800 ms-3">تخفیف خرید آنلاین </span></td>
                  <td><span>{{ list.git_online }} <span>%</span></span></td>
                </tr>
                <tr>
                  <td class="text-right" ><span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-800 ms-3">تخفیف خرید اعتباری </span></td>
                  <td><span>{{ list.buyCredit }} <span>%</span> </span></td>
                </tr>
                <tr>
                  <td class="text-right" ><span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-800 ms-3">مدت اعتبار </span></td>
                  <td><span>{{ list.dateExpire_day }}</span> <span>روز</span></td>
                </tr>
                <tr>
                  <td class="text-right" ><span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-800 ms-3">مدت کدتخفیف </span></td>
                  <td><span>{{ list.dateExpire_gift }}</span> <span>روز</span></td>
                </tr>

                <tr>
                  <td colspan="2" style="text-align: right">
                    <span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-800 ms-3" style="text-align: right">توضیحات:</span> <br>
                    <span class="text-justify">{{ list.description }}</span></td>
                </tr>
                </tbody>
              </table>
              <button type="button"
                      class=" form-control text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                      @click="addCard(list.id , list.title ,list.price , list.git_online,list.buyCredit )"
                      v-if="status !== list.id">
                <i class="fa fa-shopping-cart text-right"></i>
                افزودن به سبد
              </button>
              <button type="button" v-else
                      class=" form-control text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                      :id="'btn_loading'+list.id">
                <svg aria-hidden="true" role="status" class="inline w-4 h-4 me-3 text-white animate-spin"
                     viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"/>
                  <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"/>
                </svg>
                افزودن به سبد
              </button>            </div>


          </div>
    <div class="col-md-11 mt-5">
      <nav class="text-danger">
        <ul class="pagination  " style="justify-content: center;">
          <li class="page-item">
            <button class="btn btn-light " :disabled="!paginatetion.first_page_url" href="#"
                    v-on:click="myPaginate(paginatetion.first_page_url)" title="اولین"><i
                class="fa fa-angle-double-right"></i></button>
            <button class="btn btn-light " :disabled="!paginatetion.prev_page_url" href="#"
                    v-on:click="myPaginate(paginatetion.prev_page_url)" title="قبلی"><i
                class="fa fa-angle-right"></i></button>
          </li>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <li class="page-item">
            <button class="btn btn-light" v-on:click="myPaginate(paginatetion.next_page_url)"
                    :disabled="!paginatetion.next_page_url" title="بعدی">
              <i class="fa fa-angle-left"></i></button>

            <button class="btn btn-light " :disabled="!paginatetion.last_page_url" href="#"
                    v-on:click="myPaginate(paginatetion.last_page_url)" title="اخرین"><i
                class="fa fa-angle-double-left"></i></button>
          </li>
        </ul>
      </nav>
    </div>
  </section>
</template>
<script setup>
import axios from "axios";
import {useStore} from 'vuex'
import * as number from "../../../common/helpers/Number"
import config from "../../../../config/config.json";
import {$ref} from "vue/macros";
import Loading from "@/agent/components/Layout/loadings/index.vue";


let statusLoading = $ref('true');
setTimeout(() => {
  statusLoading = false;
}, 1500);

let status = $ref('');
let paginatetion = $ref({})
let listPanel = $ref([])
const store = useStore()
let url = `${config.BASE_URL}/panels`;

function addCard(id, title, price, git_online, buyCredit) {
  status = id
  store.dispatch('addToCart', {id: id, title: title, price: price, 'buyCredit': buyCredit, 'git_online': git_online})
  setTimeout(() => {
    status = '';
  }, 1000);
}

async function getPanel() {
  try {
    const res = await axios.get(url);
    listPanel = (res.data.status) ? res.data.data.data : ""
    makePaginatetion(res.data.data);
  } catch (e) {
    console.log(e)
  }
}

function makePaginatetion(data) {
  let paginatetions = {
    current_page: data.current_page,
    last_page_url: data.last_page_url,
    next_page_url: data.next_page_url,
    prev_page_url: data.prev_page_url,
    first_page_url: data.first_page_url
  }
  paginatetion = paginatetions;
}

function myPaginate(urls) {
  url = urls;
  getPanel()
}

getPanel()
</script>